import { RequestStatus, RequestType, RequestView } from "../firestore/Types/RequestSchema";
import { StatusTag, StatusTagColor, TagSize } from "./Account/StatusTag";

export function RequestRow({ request }: { request: RequestView}) {
    var statusText = "Pending";
    var statusTagColor = StatusTagColor.Yellow;
    if (request.Status === RequestStatus.Pending) {
        statusText = "Pending";
        statusTagColor = StatusTagColor.Yellow;
    }
    else if (request.Status === RequestStatus.Approved) {
        statusText = "Approved";
        statusTagColor = StatusTagColor.Green;
    }
    else if (request.Status === RequestStatus.Rejected) {
        statusText = "Rejected";
        statusTagColor = StatusTagColor.Red;
    }

    var type = "None";
    if (request.Type === RequestType.WWCC) {
        type = "WWCC Verification";
    }
    else if (request.Type === RequestType.Interview) {
        type = "Interview Booking";
    }
    return (
        <a href={"/view_admin_request/?requestId=" + request.Id}>
            <div className="flex flex-row bg-white rounded-lg border-solid border-2 m-2 p-2 border-gray-300 w-full hover:bg-slate-200">
                <div className="flex flex-col grow p-2">
                    <div className="flex flex-row">
                        <div className="flex flex-row grow gap-4">
                            <div className="flex flex-row">
                                <StatusTag statusText={statusText} statusTagColor={statusTagColor} tagSize={TagSize.Medium}></StatusTag>
                            </div>
                            <div className="flex flex-row">
                                <h2 className="text-2xl text-bold text-sky-500">{type}</h2>
                            </div>
                        </div>
                        <div className="flex flex-col m-2">
                            <div className="flex flex-row">
                                <div className="text-xl">{request.Date.toDate().toLocaleString()}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </a>
    );
}